module.exports = __webpack_public_path__ + "static/media/archive.7e7cd92b.png";